/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';

import Colors from '@userzoomlibraries/toolkit-themes-userzoom-platform-globals/colors';
import { UiBreakpoint } from '../utils/constants';

const globalStyles = css`
	html {
		// Preserve font-size between portrait/landscape orientation changes
		-webkit-text-size-adjust: 100%;
	}

	html,
	body {
		margin: 0;
		padding: 0;
		background-color: ${Colors.grey100}; // JS variable for IE11
		min-height: 100vh;

		@media (max-width: ${UiBreakpoint}px) {
			background-color: ${Colors.white};
		}
	}
	body {
		-webkit-overflow-scrolling: touch;
	}

	* {
		box-sizing: border-box;
	}

	.link-text {
		display: inline-flex;
		color: ${Colors.action500};
		cursor: pointer;
		outline: none;
		&:hover {
			color: ${Colors.action600};
			text-decoration: underline;
		}
	}
`;

export default globalStyles;
